module.exports = __webpack_public_path__ + "media/images/home/cover-desktop@3x-63c05e502fe7e4ad696a9106c03793c9.jpg";